import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface ConditionFieldProps {
  label: ReactNode;
  labelFor?: string;
  helpText?: ReactNode;
  helpPlacement?: 'before' | 'after';
  children: ReactNode;
  className?: string;
}

export function ConditionField({
  label,
  labelFor,
  helpText,
  helpPlacement = 'after',
  children,
  className,
}: ConditionFieldProps) {
  const help = helpText ? (
    <div className="text-sm text-muted-foreground">{helpText}</div>
  ) : null;

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <Label htmlFor={labelFor}>{label}</Label>
      {helpPlacement === 'before' ? help : null}
      <div className="w-full">{children}</div>
      {helpPlacement === 'after' ? help : null}
    </div>
  );
}
